import gameTitlesData from '../../../data/game_titles.json'

const gameTitleIds = gameTitlesData
  .filter((game) => game.isArchived !== true)
  .map((game) => game.gameTitleId ?? '')
  .filter((gameTitleId) => gameTitleId !== '')

export const gameTitles = [...gameTitleIds] as const

export type GameTitle = (typeof gameTitles)[number]

export type GameTitleInfo = {
  titleJa: string
  titleEn: string
  coverImgUrl: string
  igdbId?: number
  searchCandidates?: string[]
  displayIndex?: number
  selectedAsUserBestGameTitleCount?: number
  isArchived?: boolean
}

export const gameTitleInfos: Record<GameTitle, GameTitleInfo> =
  Object.fromEntries(
    gameTitlesData.map((game) => [
      game.gameTitleId,
      {
        titleJa: game.titleJa,
        titleEn: game.titleEn,
        coverImgUrl: game.coverImgUrl || game.coverImageUrl,
        igdbId: game.igdbId,
        searchCandidates: game.searchCandidates,
        displayIndex: game.displayIndex,
        selectedAsUserBestGameTitleCount: game.selectedAsUserBestGameTitleCount,
        isArchived: game.isArchived,
      },
    ])
  ) as Record<GameTitle, GameTitleInfo>

// 優先的に表示するゲームタイトルID
const PRIORITY_GAME_TITLES = [
  'apex',
  'myHeroAcademiaUltraRumble',
  'valorant',
  'dbd',
  'fortnite',
  'genshin',
  'genshinImpact',
  'amongus',
  'monsterhunterrise',
  'monsterHunterRiseSunBreak',
  'pokemonUnite',
  'splatoon3',
  'fallguys',
  'overwatch2',
  'codMw2',
  'codMw3',
  'codBo6',
  'pazudora',
  'gundamEvolution',
  'blueProtocol',
  'bf2042',
  'marvelRivals',
  'monsterHunterWilds',
]

export const getPopularGameTitles = (limit?: number): GameTitle[] => {
  // 通常のソート処理
  const sortedTitles = [...gameTitles]
    .filter(
      (title) =>
        gameTitleInfos[title]?.selectedAsUserBestGameTitleCount !== undefined
    )
    .sort((a, b) => {
      const countA = gameTitleInfos[a]?.selectedAsUserBestGameTitleCount || 0
      const countB = gameTitleInfos[b]?.selectedAsUserBestGameTitleCount || 0
      return countB - countA
    })

  // 優先ゲームタイトルを先頭に表示するための処理
  const priorityTitles: GameTitle[] = []
  const otherTitles: GameTitle[] = []

  // 優先順位に従ってゲームタイトルを並び替え
  PRIORITY_GAME_TITLES.forEach((priorityTitle) => {
    const foundTitle = sortedTitles.find((title) => title === priorityTitle)
    if (foundTitle) {
      priorityTitles.push(foundTitle)
    }
  })

  // 優先リストに含まれていないタイトルを別の配列に格納
  sortedTitles.forEach((title) => {
    if (!PRIORITY_GAME_TITLES.includes(title)) {
      otherTitles.push(title)
    }
  })
  const result = [...priorityTitles, ...otherTitles]
  return limit !== undefined ? result.slice(0, limit) : result
}

export const profileCardGameTitles = gameTitles

export const getGameTitleDisplayName = (gameTitle: string) => {
  // 特殊なケース「joining」の処理
  if (gameTitle === 'joining') {
    return '参加中'
  }

  // gameTitleInfosからゲームタイトルを検索
  const gameInfo = gameTitleInfos[gameTitle]

  // ゲーム情報が見つかった場合は日本語タイトルを返す
  if (gameInfo) {
    return gameInfo.titleJa
  }

  // 見つからない場合はゲームタイトルIDをそのまま返す
  return gameTitle
}
